import { render } from "./doc_Approval.vue?vue&type=template&id=48a79b5a&scoped=true"
import script from "./doc_Approval.js?vue&type=script&lang=js"
export * from "./doc_Approval.js?vue&type=script&lang=js"

import "./doc_Approval.vue?vue&type=style&index=0&id=48a79b5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a79b5a"]])

export default __exports__